import { SUPPORT_PHONE_LABEL, SUPPORT_PHONE_TEL } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function BulkBanner() {
  return (
    <section className="bulk">
      <div className="shell">
        <div className="bulk__frame">
          <strong>Buying for a team? Get up to 20% off multi-user orders.</strong>
          <span>Speak to our experts for a custom multi-seat price</span>
          <div className="bulk__actions">
            <a href={SUPPORT_PHONE_TEL} className="btn btn--white">
              Call {SUPPORT_PHONE_LABEL}
            </a>
            <button type="button" className="btn btn--outline-white" onClick={openZohoChat}>
              Live Chat
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
